import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const AllOrderV2RolesRBAC = {
  pageID: '87e7114ecc838b5a84d8a11caf91713c',
  elementID: {
    ViewPageSemuaPesanan: '38540f33897c3e7f65e9fcecbddd1b87',
    RedeliveryOrder: 'e933f1fa03fc01699b17a0dd266f685d',
    CompleteKitchenDetail: 'f4b125a8895097eca4d9e78fdbc00df4',
    ViewAllLocation: '78e58eef70e3a23c3b97447531530bf9',
    TagUntagPooling: 'ea46171f96b02af10dfbdb36aae24787',
    Call3PL: '256bcff3723bdc36bbd5ba07f09755eb',
    CancelOrder: '70f357eb58aab75d148f6caf8b4e1a92',
    SkipVerifiyLocation: '99f10b78864787ae96b05a626dcdc3ea',
    OnHoldOrder: 'a3b7e1b253cc1da751f536c977afdd48',
    SearchSemuaPesanan: 'b5c14c42c74e257385dbe056ff45ea39',
    FilterOrder: '05e2dbb6bd84cdddf07bd8d00fd8394a',
    ViewDetailOrder: '88fcc46347cef8e49cd1bfd2719447b4',
    SkipVerifiyDropOff: '4419ab7b4bcb66d4ab085e073bc0fbcb',
    ConfirmGrabmartPartialOrder: '14318c3892eaa792b17e14525efce3f3',
    EditAddress: 'e218010182797a898e3cd3238e2050c8',
    SudoCancelOrder: '1798caa658f55adf6b4234c90981109b',
    ViewKitchenDetail: '335c2935facdd182bb30710cfa81f472',
    ViewUserSegment: '3604278b1846b728d4ad8951c03dd801',
    CompleteOrder: 'e94e06c4be4dbe41df338a6937eb031f',
    SkipVerifyPackage: 'da367cd745608b4bfe687c10482544da',
  },
} as const

export const useRBACAllOrderV2Page = createUseRBAC(AllOrderV2RolesRBAC.elementID)

export type UseRBACAllOrderV2PageType = ReturnType<typeof useRBACAllOrderV2Page>
